<template>
  <v-app class="v-app">

    <mobile-navigation-menu :menuVisible="menuVisible" />

    <mobile-article-filter v-if="$mq === 'mobile' || $mq === 'tablet'" :menuVisible="filterMenuVisible"/>

    <div id="app">

      <img class="background-img" :src="townBackgroundSrc" />
      
      <mobile-toolbar :headerHeight="headerHeight" v-if="$mq === 'mobile' || $mq === 'tablet'" />

      <page-header v-if="$mq !== 'mobile' && $mq !== 'tablet'" class="page-header"/>

      <nav-header v-if="$mq !== 'mobile' && $mq !== 'tablet'" />
      

      <div class="page-box" ref="pageBox">

        <router-view :key="$route.fullPath" />

      </div>

      <PageFooter />


    </div>
  </v-app>
</template>


<script lang="ts">
  import { Component, Vue } from 'vue-property-decorator';
  import PageHeader from '@/components/PageHeader.component.vue';
  import PageFooter from '@/components/PageFooter.component.vue';
  import NavHeader from './components/NavHeader.component.vue';
  import MobileToolbar from './components/MobileToolbar.component.vue';
  import MobileNavigationMenu from './components/MobileNavigationMenu.component.vue';
  import MobileArticleFilter from './components/filtering/MobileArticleFilter.component.vue';
  import {AuthenticationService} from '@/services/authentication.service';
  import axios from 'axios';
  import * as Consts from '@/scripts/Consts';

  const imgHeight = 275;
  const imgWidth = 787;

  @Component({
    components: {
      'page-header': PageHeader,
      'PageFooter': PageFooter,
      'nav-header' : NavHeader,
      'mobile-toolbar' : MobileToolbar,
      'mobile-navigation-menu' : MobileNavigationMenu,
      'mobile-article-filter' : MobileArticleFilter
    },
  })
  export default class App extends Vue {
    headerHeight = imgHeight;

    menuVisible = false;
    filterMenuVisible = false;

    townBackgroundSrc = '/img/town background.jpg';

    private isDestroyed = false;

    private userActionHandler = () => {
      if (this.isDestroyed) return;
      this.refreshTokenOnUserAction();
    };

    mounted() : void {
      if( (this as any).$mq === 'mobile' || (this as any).$mq === 'tablet') {
        this.townBackgroundSrc = '/img/town background mobile.jpg';
        this.headerHeight = imgHeight * (window.outerWidth / imgWidth);
        setTimeout(() => {
          (this.$el.querySelector(".page-box") as HTMLElement).style.marginTop = (this.headerHeight + 30) + "px";
        }, 200);
      }
      this.$root.$on('show-menu', (value : boolean) => {
        this.showMenu(value);
      });
      this.$root.$on('show-filter-menu', (value : boolean) => {
        this.showFilterMenu(value);
      });

      this.bindTokenRefreshOnUserAction();
      this.refreshTokenOnUserAction();
    }

    beforeDestroy() : void {
      this.isDestroyed = true;
      window.removeEventListener('click', this.userActionHandler);
      window.removeEventListener('keydown', this.userActionHandler);
      window.removeEventListener('touchstart', this.userActionHandler);
    }

    showMenu(value : boolean) : void {
      this.menuVisible = !value;
      setTimeout(() => {
        this.menuVisible = value;
      });
    }

    showFilterMenu(value : boolean) : void {
      this.filterMenuVisible = !value;
      setTimeout(() => {
        this.filterMenuVisible = value;
      });
    }


    bindTokenRefreshOnUserAction() : void {
      window.addEventListener('click', this.userActionHandler);
      window.addEventListener('keydown', this.userActionHandler);
      window.addEventListener('touchstart', this.userActionHandler);
      this.$router.afterEach(this.userActionHandler);
    }

    refreshTokenOnUserAction() : void {
      AuthenticationService.refreshTokenIfNeeded(axios).then((response) => {
        if(response === 1) {
          this.$root.$emit('login');
        }
        else if(response === 2) {
          this.$root.$emit('logout');
          this.$router.push('/connexion');
        }
      }).catch((err) => {
        console.error("err", err);
      });
    }
  }
</script>

<style>
  @import './assets/styles/variables.css';
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--main-text-color);
    background-color: unset;
    text-align: unset !important;
    font-family: Candara, "Comic Sans MS", sans-serif;;
    font-size: 1.08em;
  }

  .v-app {
    display: block !important;
  }

  .background-img {
    position: fixed;
    bottom: 0;
    z-index: -1;
    width: 100%;
    height: 100vh;
  }

  .v-application--wrap {
    min-height: 100% !important;
  }

  .page-box {
    margin-top: 30px;
    margin-bottom: 30px;
    /*min-width: 500px;*/
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    background-color: white;
    border-radius: var(--page-border-radius);
  }

  @media only screen and (max-width: 900px) {
    .page-box {
      max-width: unset;
      margin-top: 180px;
    }

    .page-header {
      margin-top: 120px;
    }
  }

  @media only screen and (min-width: 901px) {
    .page-box {
        max-width: var(--page-size);
    }
  }

  .v-navigation-drawer {
    height: 100% !important;
  }


  #nav {
    padding: 30px;
  }
  #nav a {
    font-weight: bold;
    color: #2c3e50;
  }
  #nav a.router-link-exact-active {
    color: #42b983;
  }
</style>